import React from "react";
import "./SelectWallet.css";
import metamask from "../../images/wallet images/metamask.svg";
import chevron from "../../images/wallet images/chevron.svg";
import walletconnect from "../../images/wallet images/walletconnect.svg";

const SelectWallet = ({ hideWalletModal }) => {
  return (
    <div className="connect-wallet-modal">
      <div className="select-prompt">
        <div className="horizon-rule">
          <div className="header">
            <h3>Connect Wallet</h3>
            <button onClick={() => hideWalletModal()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-5 h-5"
              >
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
            </button>
          </div>
        </div>
        <div className="message">
          <p>Choose your preferred wallet:</p>
        </div>
        <div className="wallet-container metamask">
          <img src={metamask} alt="" className="wallet" />

          <button className="chevron">
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.38381 8.00009C9.38381 8.26892 9.28117 8.53771 9.07631 8.74267L2.62657 15.1923C2.21628 15.6026 1.55108 15.6026 1.14096 15.1923C0.730845 14.7822 0.730845 14.1172 1.14096 13.7068L6.84805 8.00009L1.14116 2.2933C0.731043 1.88301 0.731043 1.21801 1.14116 0.807924C1.55128 0.397442 2.21648 0.397442 2.62677 0.807924L9.07651 7.2575C9.2814 7.46256 9.38381 7.73135 9.38381 8.00009Z"
                fill="#959DA6"
              />
            </svg>
          </button>
        </div>
        <div className="wallet-container">
          <img src={walletconnect} alt="" className="walletconnect" />

          <button className="chevron">
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.38381 8.00009C9.38381 8.26892 9.28117 8.53771 9.07631 8.74267L2.62657 15.1923C2.21628 15.6026 1.55108 15.6026 1.14096 15.1923C0.730845 14.7822 0.730845 14.1172 1.14096 13.7068L6.84805 8.00009L1.14116 2.2933C0.731043 1.88301 0.731043 1.21801 1.14116 0.807924C1.55128 0.397442 2.21648 0.397442 2.62677 0.807924L9.07651 7.2575C9.2814 7.46256 9.38381 7.73135 9.38381 8.00009Z"
                fill="#959DA6"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectWallet;
